import Link from "next/link";

const mdOptions = {
  overrides: {
    a: { component: Link },
    //   li: {
    //     component: MarkdownListItem,
    //   },
  },
};

//   function MarkdownListItem(props) {
//     return (
//       <Box component="li" sx={{ mt: 1, typography: "body1" }} {...props} />
//     );
//   }

export default mdOptions;
